import React from "react";
import phoneImage from "../../public/image/phone.png";
// import mobileImage from '../../public/image/mobile.png'
// import rubikaImage from '../../public/image/rubika.png'
// import telegramImage from '../../public/image/telegram.png'
import manImage from "../../public/image/back.jpg";
import Image from "../shared/Image";
import logo from "./../../public/image/logo192.png";
// import axios from "axios";
// import jsFileDownload from "js-file-download";
// import config from "../../config.json";
// import toast from "react-hot-toast";
// import { CircularProgressbar } from "react-circular-progressbar";
// import { buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import neshanImage from "../../public/image/neshan.png";

const ContactUs = () => {
    // const [downloadPercent, setDownloadPercent] = useState(0);
    // const controllerRef = useRef(new AbortController());

    // const fileDownload = (url, filename) => {
    //     axios
    //         .get(url, {
    //             signal: controllerRef.current.signal,
    //             responseType: "blob",
    //             onDownloadProgress: (progressEvent) => {
    //                 let progress = Math.round(
    //                     (progressEvent.loaded / progressEvent.total) * 100,
    //                 );
    //                 setDownloadPercent(progress);
    //                 if (progress >= 100) {
    //                     setTimeout(() => {
    //                         setDownloadPercent(0);
    //                     }, 2000);
    //                 }
    //             },
    //         })
    //         .then((res) => {
    //             jsFileDownload(res.data, filename);
    //         })
    //         .catch((err) => {
    //             if (err.message && err.message !== "canceled")
    //                 toast.error("خطایی رخ داده است");
    //         });
    // };

    return (
        <div className="px-sm-2 pt-3 pt-sm-0">
            <header>
                <h5 className="fw-bold text-dark text-center mb-3 rtl">
                    ارتباط با ما
                </h5>
            </header>
            <div
                className="communication-layer"
                style={{
                    fontSize: window.innerWidth >= 576 ? "1rem" : ".9rem",
                }}
            >
                {/* {
                    !window.isRNWebView &&
                    <button className="d-flex flex-row justify-content-start align-items-center alert alert-light py-2 w-100"
                        style={{ height: '67px' }}
                        onClick={() => fileDownload(`${config.api_address + config.api_user}/download-app`, 'آلماتک.apk')}
                        disabled={downloadPercent > 0}
                    >
                        <Image
                            src={logo}
                            width={40}
                            height={40}
                            borderRadius={'10px'}
                        />
                        <div className='ms-2'>دانلود فایل اندروید برنامه (apk) <i className='fa fa-download ms-2 fs-5'></i></div>
                        {
                            downloadPercent > 0 &&
                            <div style={{ width: '50px' }} className='mx-auto'>
                                <CircularProgressbar
                                    value={downloadPercent}
                                    text={`${downloadPercent}%`}
                                    styles={buildStyles({
                                        textColor: "#198754",
                                        pathColor: "#198754",
                                        trailColor: "#19875457",
                                        textSize: "25px",
                                        strokeLinecap: "butt",
                                        pathTransition:
                                            downloadPercent === 0 ? "none" : "stroke-dashoffset 0.5s ease 0s"
                                    })
                                    }

                                />
                            </div>
                        }
                    </button>
                } */}
                <div className="d-flex flex-row justify-content-start align-items-center alert alert-light">
                    <Image
                        src={phoneImage}
                        width={38}
                        height={33}
                        borderRadius={"10px"}
                    />
                    <div className="ms-2">تلفن: 09192770652</div>
                </div>
                <p
                    style={{ textAlign: "justify", fontSize:'.9rem' }}
                    className="alert alert-light"
                >
                    <i className="fa fa-map-marker me-2"></i>
                    آدرس : شهرک امیرکبیر، جنب میدان امیرکبیر، روستا بازار مرکزی
                    زنجان
                </p>
                <button
                    className="d-flex flex-row justify-content-start align-items-center alert alert-light py-2 w-100"
                    style={{ height: "67px" }}
                    onClick={() =>
                        (window.location = "https://nshn.ir/4c7bfBV1W5tXYv")
                    }
                >
                    <Image
                        src={logo}
                        width={40}
                        height={40}
                        borderRadius={"10px"}
                    />
                    <div className="ms-2 d-flex align-items-center">
                        <span className="me-1"> مشاهده در نقشه</span>
                        <Image
                            src={neshanImage}
                            width={65}
                            // height={10}
                        />
                    </div>
                </button>

                {/* <div className="d-flex flex-row justify-content-start align-items-center alert alert-light">
                    <Image
                        src={mobileImage}
                        width={38}
                        height={38}
                        borderRadius={'10px'}
                    />
                    <div className='ms-2'>09155162699 (سیدامیر غفوری)</div>
                </div> */}
                {/* <div className="d-flex flex-row justify-content-start align-items-center alert alert-light">
                    <Image
                        src={mobileImage}
                        width={38}
                        height={38}
                        borderRadius={'10px'}
                    />
                    <div className='ms-2'>09055540128</div>
                </div> */}
                {/* <div className="d-flex flex-row justify-content-start align-items-center alert alert-light">
                    <Image
                        src={rubikaImage}
                        width={38}
                        height={38}
                        borderRadius={'10px'}
                    />
                    <a className="social-icon ms-2" href={'https://rubika.ir/AlbourzIndustrialGroup'}>
                        https://rubika.ir/AlbourzIndustrialGroup
                    </a>
                </div>
                <div className="d-flex flex-row justify-content-start align-items-center alert alert-light">
                    <Image
                        src={telegramImage}
                        width={38}
                        height={38}
                        borderRadius={'10px'}
                    />
                    <a className="social-icon ms-2 " href={'https://t.me/AlbourzIndustrialGroup'}>
                        https://t.me/AlbourzIndustrialGroup
                    </a>
                </div> */}
                <div className="d-flex flex-row justify-content-start align-items-center alert alert-light">
                    <Image
                        src={manImage}
                        width={44}
                        height={44}
                        borderRadius={"10px"}
                    />
                    <div className="ms-2">پشتیبانی فنی سایت</div>
                    <div className="mx-2">:</div>
                    <div className="">09903903847</div>
                </div>
            </div>
        </div>
    );
};

export default ContactUs;
